import TestSummary from 'src/containers/TestSummary/TestSummary';

export default TestSummary;